import { render } from "./Products-add.vue?vue&type=template&id=7899169a"
import script from "./Products-add.vue?vue&type=script&lang=js"
export * from "./Products-add.vue?vue&type=script&lang=js"

import "./Products-add.vue?vue&type=style&index=0&id=7899169a&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__